import React from 'react';
import { intl, TextInput, useManagedForm, yup } from 'ehs-react';
import { usePortletStore } from '../../App';
import { requestResetPassword } from '../../stores/ajax';

function PasswordResetRequestPageComponent({
  onNextPage
}: {
  onNextPage: () => void;
}): JSX.Element {
  const emailValidation = usePortletStore(
    state => state.configuration.emailValidationConfiguration.regex
  );

  const managedForm = useManagedForm<{ email: string }>({
    validateOnChange: true,
    validateOnMount: true,
    initialValues: { email: '' },
    validationSchema: yup
      .object()
      .shape({
        email: yup
          .string()
          .defined()
          .matches(
            new RegExp(emailValidation),
            intl('resetpasswordportlet.input.email.invalid')
          )
      })
      .required(),
    onSubmit(values): void | Promise<void> {
      requestResetPassword(values.email, onNextPage);
    }
  });

  return (
    <form {...managedForm.getFormProps()}>
      <div className="input-container">
        <TextInput
          debounceWait={300}
          label={intl('resetpasswordportlet.input.email.label')}
          placeholder={'email@email.email'}
          type="text"
          autoFocus={true}
          {...managedForm.getField('email')}
          error={
            !managedForm.isValid
              ? intl('resetpasswordportlet.input.email.invalid')
              : ''
          }
        />
      </div>
      <div className="password-reset-button">
        {managedForm.getSubmitButton({
          disableIfNotDirty: true,
          disableIfNotValid: true,
          text: intl('resetpasswordportlet.button.text')
        })}
      </div>
    </form>
  );
}

export const PasswordResetRequest = PasswordResetRequestPageComponent;
